import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignInAlt, FaEnvelope, FaLock } from 'react-icons/fa';
import { loginUser } from '../services/api';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/Loader';
import { useT } from '../i18n/LanguageContext';
import './Auth.css';

const T = {
    en: {
        loginFailed: 'Login failed. Please try again.',
        welcomeBack: 'Welcome Back',
        subtitle: 'Sign in to your account to make purchases',
        email: 'Email',
        emailPlaceholder: 'Enter your email',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        signingIn: 'Signing in',
        signIn: 'Sign In',
        adminNote: 'Account created by admin. Contact your administrator if you need access.',
    },
    fr: {
        loginFailed: 'Échec de la connexion. Veuillez réessayer.',
        welcomeBack: 'Bon retour',
        subtitle: 'Connectez-vous à votre compte pour effectuer des achats',
        email: 'E-mail',
        emailPlaceholder: 'Saisissez votre e-mail',
        password: 'Mot de passe',
        passwordPlaceholder: 'Saisissez votre mot de passe',
        signingIn: 'Connexion en cours',
        signIn: 'Se connecter',
        adminNote: "Compte créé par l'administrateur. Contactez votre administrateur si vous avez besoin d'un accès.",
    },
};

function Login() {
    const t = useT(T);
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const res = await loginUser(formData);
            login(res.data.token, res.data.user);
            navigate('/products');
        } catch (err) {
            setError(err.response?.data?.error || t.loginFailed);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <FaSignInAlt className="auth-icon" />
                    <h2>{t.welcomeBack}</h2>
                    <p>{t.subtitle}</p>
                </div>

                {error && <div className="auth-error">{error}</div>}

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label><FaEnvelope /> {t.email}</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder={t.emailPlaceholder}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label><FaLock /> {t.password}</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder={t.passwordPlaceholder}
                            required
                        />
                    </div>

                    <button type="submit" className="auth-btn" disabled={loading}>
                        {loading ? <Loader inline label={t.signingIn} /> : t.signIn}
                    </button>
                </form>

                <p className="auth-switch">
                    {t.adminNote}
                </p>
            </div>
        </div>
    );
}

export default Login;
